import { push } from '@lagunovsky/redux-react-router'
import { Card, CardContent, Grid } from '@mui/material'
import CampaignAction from 'campaign/actions/CampaignAction'
import { getCampaignIcon } from 'campaign/utils/CampaignUtils'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import i18n from 'simple-react-i18n'
import { getColorCampaign } from 'utils/CampaignUtil'
import { getFullDate } from 'utils/DateUtil'
import PropTypes from 'prop-types'
import { getStationTypeNameFromType } from 'utils/StationUtils'

const DashboardCampaignCard = ({
    stationType,
}) => {
    const { id } = useParams()
    const dispatch = useDispatch()

    const [campaigns, setCampaigns] = useState([])

    useEffect(() => {
        if (!stationType) return
        CampaignAction.getCampaignByStation(getStationTypeNameFromType(stationType), id).then((res = []) => setCampaigns(res))
    }, [id, stationType])

    const filteredCampaigns = campaigns.filter(c => c.statut === 2)

    // remove margin
    return (
        <Grid container direction='column' spacing={1} sx={{ marginBottom: '10px' }}>
            {filteredCampaigns.map(c => (
                <Grid key={c.id}>
                    <Card colorBorderLeft={getColorCampaign(c.isArchived, 0, c.statut)} onClick={() => dispatch(push(`/${stationType}/campaign/${c.id}`))}>
                        <CardContent padding={0}>
                            <Grid container>
                                <Grid size={12} sx={{ paddingLeft: '5px', paddingTop: '5px' }}>
                                    <span style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>{c.name}</span>
                                </Grid>
                                <Grid size={12} sx={{ paddingLeft: '5px' }}>
                                    <span style={{ fontSize: '1rem', fontStyle: 'italic', color: '#616161' }}>{c.beginningApplication} {i18n.to} {c.endingApplication}</span>
                                </Grid>
                                <Grid container size={12} sx={{ padding: '0 5px', backgroundColor: '#EEE' }} alignItems='center'>
                                    <Grid size='grow'>
                                        {i18n.atDate} {getFullDate(c.updateDate)} {i18n.by} {c.updateLogin}
                                    </Grid>
                                    <Grid size='auto'>
                                        {getCampaignIcon(c.campaignType)}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    )
}

DashboardCampaignCard.propTypes = {
    stationType: PropTypes.string,
}

export default DashboardCampaignCard